import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ProfileService } from '../services/profile.service';
import { catchError, map, of, switchMap } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const profileService = inject(ProfileService);

  // Leitura fresca dos cookies (evita signal stale entre abas / após expiração).
  authService.syncTokensFromCookies();

  if (authService.getAccessToken()) {
    return ensureProfileLoaded(authService, profileService);
  }

  const refresh = authService.getRefreshToken();
  if (!refresh) {
    router.navigate(['/login']);
    return false;
  }

  return authService.refreshAccessToken().pipe(
    switchMap(() => {
      if (!authService.getAccessToken()) {
        authService.signOutLocally();
        return of(false);
      }
      return ensureProfileLoaded(authService, profileService);
    }),
    catchError(() => {
      authService.signOutLocally();
      return of(false);
    })
  );
};

function ensureProfileLoaded(
  authService: AuthService,
  profileService: ProfileService,
) {
  if (profileService.loaded()) {
    return of(true);
  }

  return profileService.getUserProfile().pipe(
    map(() => true),
    catchError(() => {
      authService.signOutLocally();
      return of(false);
    })
  );
}
